import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";

const COLORS = ["#22d3ee", "#3b82f6", "#8b5cf6", "#f59e0b"];

const formatNum = (n) => n >= 100000 ? `${(n / 100000).toFixed(1)}L` : `${(n / 1000).toFixed(0)}K`;

export default function RegionalBreakdown({ regions }) {
  const totalDemand = regions.reduce((s, r) => s + r.actual, 0);
  const data = regions.map(r => ({
    name: r.region.replace(" India", ""),
    value: r.actual,
    revenue: r.revenue,
    pct: totalDemand > 0 ? ((r.actual / totalDemand) * 100).toFixed(1) : 0,
  }));

  const CustomTooltip = ({ active, payload }) => {
    if (!active || !payload?.length) return null;
    const d = payload[0].payload;
    return (
      <div className="bg-slate-900 border border-slate-700 rounded-lg px-3 py-2 text-xs shadow-xl">
        <p className="text-slate-300 font-medium">{d.name} India</p>
        <p className="text-cyan-400">Demand: {d.value.toLocaleString()} units</p>
        <p className="text-emerald-400">Revenue: INR {formatNum(d.revenue)}</p>
        <p className="text-slate-400">Share: {d.pct}%</p>
      </div>
    );
  };

  return (
    <div className="bg-slate-900/40 border border-slate-800 rounded-2xl p-6" data-testid="regional-breakdown">
      <h3 className="text-base font-semibold text-white mb-1" style={{ fontFamily: 'Outfit, sans-serif' }}>Regional Distribution</h3>
      <p className="text-xs text-slate-500 mb-4">Demand share by geography</p>
      <div className="flex items-center gap-6">
        <ResponsiveContainer width="50%" height={220}>
          <PieChart>
            <Pie data={data} cx="50%" cy="50%" innerRadius={55} outerRadius={85} paddingAngle={3} dataKey="value">
              {data.map((_, i) => <Cell key={i} fill={COLORS[i % COLORS.length]} />)}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
          </PieChart>
        </ResponsiveContainer>
        <div className="flex-1 space-y-3">
          {data.map((d, i) => (
            <div key={d.name} className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: COLORS[i] }} />
                <span className="text-xs text-slate-300">{d.name}</span>
              </div>
              <div className="text-right">
                <span className="text-xs font-medium text-white">{d.pct}%</span>
                <span className="text-[10px] text-slate-500 ml-2">{formatNum(d.value)}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
